import {
  AlwaysValidOptions,
  BooleanFieldValidations,
  DateFieldValidations,
  FieldTypes,
  InputFieldValidations,
  MoneyFieldValidations,
  NumberFieldValidations,
  PhoneFieldValidations,
  StringFieldValidations,
} from '@zinnia/form-engine-sdk';

export function isOptionFieldType(fieldType: unknown): boolean {
  return (
    fieldType === FieldTypes.dropdown ||
    fieldType === FieldTypes.checkboxGroup ||
    fieldType === FieldTypes.radio ||
    fieldType === FieldTypes.checkbox
  );
}

export function isAgreeFieldType(fieldType: unknown): boolean {
  return fieldType === FieldTypes.agree;
}

export function isAddressAutocompleteFieldType(fieldType: unknown): boolean {
  return fieldType === FieldTypes.autocomplete;
}

// Select options in the frontend and changes applied in the backend should both use the same mapping between field type and validation.
export const fieldTypeToValidation = {
  [FieldTypes.agree]: BooleanFieldValidations,
  [FieldTypes.checkbox]: BooleanFieldValidations,
  [FieldTypes.button]: BooleanFieldValidations,
  [FieldTypes.input]: InputFieldValidations,
  [FieldTypes.number]: NumberFieldValidations,
  [FieldTypes.money]: MoneyFieldValidations,
  [FieldTypes.date]: DateFieldValidations,
  [FieldTypes.phone]: PhoneFieldValidations,
  [FieldTypes.currencyCard]: NumberFieldValidations,
  [FieldTypes.information]: StringFieldValidations,
  [FieldTypes.autocomplete]: StringFieldValidations,
  [FieldTypes.textarea]: StringFieldValidations,
  [FieldTypes.radio]: StringFieldValidations,
  [FieldTypes.dropdown]: StringFieldValidations,
  [FieldTypes.checkboxGroup]: StringFieldValidations,
  [FieldTypes.signature]: [AlwaysValidOptions.signature],
  [FieldTypes.yearMonth]: DateFieldValidations,
  [FieldTypes.custom]: [AlwaysValidOptions.custom],
};
